import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {store, Ability} from './store/index'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import "./plugins/vue-auth";

Vue.config.productionTip = false

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css';
import i18n from './i18n'
Vue.use(VueSweetalert2)


Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2
  });
  return formatter.format(value);
});


import CardLoading from './components/shared/CardLoading'
import DialogLoading from './components/shared/DialogLoading'
Vue.component('dialog-loading', DialogLoading)
Vue.component('card-loading', CardLoading)


new Vue({
  router,
  store,
  vuetify,
  i18n,
  Ability,
  render: h => h(App)
}).$mount('#app')
